export const PROGRAM_IDS = {
  // LAS
  LAS_CA: "M7X8T953BKVSG",
  LAS_CHUB: "LNA4FTCKB004M",
  LAS_CSM: "LQGK18YODQ6D2",
  LAS_MTS: "LNA4FTCKB003M",
  LAS_NQP: "M9BG7MD6N63H0",
  // NEAS
  NEAS_EPRR: "M47YSAO1MFX4B",
  NEAS_NQP: "M167IR37RNSSQ",
  // NWAS
  NWAS_EPRR: "LR0HYZYWY6JQK",
  NWAS_ARC: "MB81RFIVJPE1N",
  NWAS_NQP: "LZCUV68I1O975",
  // SWAST
  SWAST_HART: "LNA4FTCKB002M",
  SWAST_HART_EPRR: "LNLT7JSYDT5PJ",
  SWAST_PRECEPTORSHIP: "LNA4FTCKB012M",
  SWAST_NQP2: "LNA4FTCKB005M",
  SWAST_SP_AP_RP: "MB80U7V2XXYQQ",
  SWAST_EPRR: "ML552BKR9TKS7",
  // YAS
  YAS_NQP: "M7EPWBZE8P2XK",
  // University of Cumbria
  UOC_APPRENTICESHIP: "MRNKO1ENPLPPS",
  // TEST PROGRAM
  TEST_PROGRAM: "M7N9K0Y7IOUMI",
};

export const PROGRAM_EVIDENCE_DEFINITION_IDS = {
  UOC_ROPP: "MRUEUBP2E9KZC",
  UOC_CAP: "MRUEV2RXPOJ83",
};

export const PROGRESS_CHECK_IDS = {
  LAS_CHUB_ONGOING_DEVELOPMENT: "LUK25EYB6DL4A",
  LAS_CA_ONGOING_DEVELOPMENT: "M7X8U3UJH6UG5",
  LAS_MTS_MENTORING: "LUK23YT16I5Q2",
  LAS_CHUB_MENTORING: "LW99UWW8FT3WY",
  LAS_CA_MENTORING: "M8OBZWT51MZE3",
  LAS_CA_COURSES: "M8OBM9PFO212S",
  SWAST_PRECEPTORSHIP_RECALL_DAY_REFLECTIONS: "LNA4GMRKB061M",
  SWAST_PRECEPTORSHIP_BAND_6_REFLECTIONS: "LNA4GMRKB071M",
  NEAS_NQP_INDUCTION: "M3SV6JHDWJ654",
  SWAST_SP_AP_RP_RADIOLOGY_AUDITS: "MDYFWQ2Y5S9XJ",
};

export const COMPETENCY_IDS = {
  LAS_CHUB_ONGOING_DEVELOPMENT_GENERAL_COMPETENCY: "LWAGQ8UP7YU3L",
  LAS_CA_ONGOING_DEVELOPMENT_GENERAL_COMPETENCY: "M7X8TC6Z5XM93",
  LAS_CA_ONGOING_DEVELOPMENT_PARAPASS_LEARNING_COMPETENCY: "MEBDN9OUQPQ7Q",
  SWAST_SP_AP_RP_CPD_ENTRY: "MBTKH2X2SUOW1",
};

export const LEARNING_OUTCOMES_IDS = {
  LAS_CHUB_ONGOING_DEVELOPMENT_LO: "LX4VATNYDQGT7",
  LAS_CA_ONGOING_DEVELOPMENT_LO: "M7X8TC1HIPQF2",
};

export const AUTOCOMPLETE_PROGRESS_CHECK_COMPETENCY_IDS = {
  NEAS_NQP_OVERVIEW_SITE: "M73G78IG69L8L",
  YAS_NQP_OVERVIEW: "M7EPWFMIBI93E",
  LAS_NQP_OVERVIEW: "M9BG7O8G6QCDM",
  SWAST_PRECEPTORSHIP_OVERVIEW: "LQZEW7C7CO6RU",
  SWAST_PRECEPTORSHIP_PRECEPTOR_SHIFT: "LVQSZILHMB8Q2",
  SWAST_PRECEPTORSHIP_VALIDATION_LOG: "LVQSO3MTY5R7X",
  SWAST_NQP_FEEDBACK_FOR_EL: "LYOBC707XLTKV",
  NWAS_NQP_MTS_TRAINING: "M3G7O75XYWB7N",
  NEAS_NQP_OVERVIEW_DOCS: "M167IU5O1QKCF",
};

export const NQP_WELLBEING_ACTIVITY_IDS = {
  SWAST_NQP: "LWKJR9KHM5VOO",
  NEAS_NQP: "M167IS03AQ03N",
  NWAS_NQP: "LZCUV746C9I8E",
  YAS_NQP: "M7EPWCSVB1DLS",
};

export const NQP_CONFIDENCE_LEVEL_COMPETENCY_IDS = {
  // SWAST Preceptorship
  SWAST_PRECEPTORSHIP_PRE: "LNA36J9UUQHQ0",
  SWAST_PRECEPTORSHIP_7_SHIFTS: "LNA36J9UUQHQ4",
  SWAST_PRECEPTORSHIP_14_SHIFTS: "LNA36J9UUQHQ6",
  SWAST_PRECEPTORSHIP_END: "LNA37J9UUQHQ1",
  SWAST_PRECEPTORSHIP_GENERAL: "LNA36J9UUQHQ1",
  // NEAS NQP
  NEAS_NQP_0_6_MONTHS: "M6Z8HDW2KEF3A",
  NEAS_NQP_6_12_MONTHS: "M6Z8IULAA8IJO",
  NEAS_NQP_12_18_MONTHS: "M6Z8JJ6E3JDOG",
  NEAS_NQP_18_24_MONTHS: "M6Z8JYY5VHR3L",
  NEAS_NQP_GENERAL: "M6Z8CKE5KO1BE",
  // YAS NQP
  YAS_NQP_0_6_MONTHS: "M7EPWG2P6KW3G",
  YAS_NQP_6_12_MONTHS: "M7EPWG72QCNYG",
  YAS_NQP_12_18_MONTHS: "M7EPWGCMJH70D",
  YAS_NQP_18_24_MONTHS: "M7EPWGIQCD92P",
  YAS_NQP_TL_SHIFT: "M7KS5NOVZ496O",
  // LAS NQP
  LAS_NQP_6_MONTH_REVIEW: "MBT82WLM3SQK3",
  LAS_NQP_12_MONTHS_REVIEW: "MBT90OE22KXDE",
  LAS_NQP_18_MONTHS_REVIEW: "MBT91TYU34YNH",
  LAS_NQP_24_MONTHS_REVIEW: "MBT92GP7IC722",
};

export const NQP_CONFIDENCE_LEVEL_PROGRESS_CHECK_IDS = {
  // SWAST Preceptorship
  SWAST_PRECEPTORSHIP_START_POINT: "LNA4GMRKB031M",
  SWAST_PRECEPTORSHIP_7_SHIFTS: "LNA4GMRKB041M",
  SWAST_PRECEPTORSHIP_14_SHIFTS: "LNA4GMRKB051M",
  SWAST_PRECEPTORSHIP_END_OF_PRECEPTORSHIP: "LNA4GMRKB081M",
  // NEAS NQP
  NEAS_NQP_0_6_MONTHS: "M3SV5PZVW27GS",
  NEAS_NQP_6_12_MONTHS: "M167LOX3P35BG",
  NEAS_NQP_12_18_MONTHS: "M167LP2NL16ST",
  NEAS_NQP_18_24_MONTHS: "M167LP736CQKK",
  // YAS NQP
  YAS_NQP_0_6_MONTHS: "M7EPXK5EWRC2K",
  YAS_NQP_6_12_MONTHS: "M7EPXKAEBRMTC",
  YAS_NQP_12_18_MONTHS: "M7EPXKMQC1IRL",
  YAS_NQP_18_24_MONTHS: "M7EPXKRMLVURA",
  // LAS NQP
  LAS_NQP_6_MONTH_REVIEW: "M9BG9A6HSMOSV",
  LAS_NQP_12_MONTHS_REVIEW: "M9BG9AA7N3BE8",
  LAS_NQP_18_MONTHS_REVIEW: "M9BG9AS5V7GS4",
  LAS_NQP_24_MONTHS_REVIEW: "M9BG9AW1A3LRJ",
};

export const PROGRAM_EVIDENCE_PART_IDS = {
  // SWAST Preceptorship
  SWAST_PRECEPTORSHIP_AREA_OF_PRACTICE_1: "LPMLMVO96BJBW",
  SWAST_PRECEPTORSHIP_AREA_OF_PRACTICE_2: "LPMLTECLVT6U5",
  // NEAS NQP
  NEAS_NQP_AREA_OF_PRACTICE_1: "M167J6D4HS385",
  NEAS_NQP_AREA_OF_PRACTICE_2: "M167J6HL6QKWM",
  // YAS NQP
  YAS_NQP_CONFIDENCE_LEVEL_TEXT_BOX: "M8EPR8Q58UVIA",
  YAS_NQP_AREA_OF_PRACTICE_1: "M7EPWRBNVSNL1",
  YAS_NQP_AREA_OF_PRACTICE_2: "M7EPWRG221NAI",
  // LAS NQP
  LAS_NQP_AREA_OF_PRACTICE_1: "M9BG86T8H192Q",
  LAS_NQP_AREA_OF_PRACTICE_2: "M9BG86YHYSZYM",
};

export const PROGRAM_SKILL_IDS = {
  SWAST_SP_AP_RP_MEDICAL_IMAGING: "MD8W1YW247FL8",
};

export const UOC_PROGRAM_EVIDENCE_DEFINITION_IDS = {
  LEVEL_5_END_OF_YEAR_REVIEW: "MRXOS5Z45BTAP",
  LEVEL_6_END_OF_YEAR_REVIEW: "MUL5WPQI9YZF1",
};

export const PROGRAM_CONSTANTS = {
  SWAST_SP_AP_RP: {
    MAX_CAPABILITIES_SELECTABLE: 3,
  },
};
